import {toString, clear as empty} from 'ui/keyboard';

function containsSignificant(state: KeyboardState): boolean {
  const value = toString(state);
  return value !== '0' && value !== '0,';
}

export function removeLastSymbol(state: KeyboardState): KeyboardState {
  if (!containsSignificant(state)) return empty();
  return [...state].slice(0, -1);
}
